export default "__VITE_ASSET__CvoBkWZv__"